import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { clsx } from 'clsx';
import * as React from 'react';
import { WebimChat } from '../../WebimChat';
import * as styles from './StandaloneChatWidgetDesktop.css';
import { jsx as _jsx } from "react/jsx-runtime";
var ANIMATION_DURATION = 1600;

/**
 * Чат без встроенных кнопок и ссылок на мессенджеры.
 * Должен открываться извне.
 */
export var StandaloneChatWidgetDesktop = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var webimProps = _ref.webimProps,
    open = _ref.open,
    onClose = _ref.onClose;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isJumping = _React$useState2[0],
    setIsJumping = _React$useState2[1];
  React.useImperativeHandle(ref, function () {
    return {
      triggerJumpAnimation: function triggerJumpAnimation() {
        if (isJumping) {
          return;
        }
        setIsJumping(true);
        setTimeout(function () {
          return setIsJumping(false);
        }, ANIMATION_DURATION);
      }
    };
  });
  return /*#__PURE__*/_jsx("div", {
    className: styles['container'],
    children: /*#__PURE__*/_jsx("div", {
      className: clsx(styles['chat-container'], isJumping && styles['jump']),
      style: {
        display: open ? '' : 'none'
      },
      "data-testid": "WebimChat",
      children: /*#__PURE__*/_jsx(WebimChat, _objectSpread(_objectSpread({}, webimProps), {}, {
        isOpen: open,
        onClose: onClose
      }))
    })
  });
});
StandaloneChatWidgetDesktop.displayName = 'StandaloneChatWidgetDesktop';